export default __webpack_public_path__ + "static/media/google.6eabe478.svg";